(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    if(document.querySelector('.dsbar')) return;
    var bar=document.createElement('div'); bar.className='dsbar'; document.body.appendChild(bar);
    var hdr=document.querySelector('.hdr');
    var raf=null;
    function onScroll(){
      if(raf) return;
      raf=requestAnimationFrame(function(){
        raf=null;
        var y=window.pageYOffset||document.documentElement.scrollTop;
        var h=document.documentElement.scrollHeight-window.innerHeight;
        bar.style.width=(h>0?Math.min(100,y/h*100):0)+'%';
        if(hdr) hdr.classList.toggle('is-stuck', y>60);
      });
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();

    if(reduce||!('IntersectionObserver' in window)) return;

    var nodes=[].slice.call(document.querySelectorAll('.sec__head,.gal__head,.card,.gal>div,.about__media,.about__txt,.ftr__brand,.panel'));
    function show(el){ el.classList.add('in'); }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var el=e.target, d=+(el.getAttribute('data-d')||0);
        setTimeout(function(){ show(el); }, d);
        io.unobserve(el);
      });
    },{threshold:0.01,rootMargin:'0px 0px -4% 0px'});
    nodes.forEach(function(el,i){
      var r=el.getBoundingClientRect();
      if(r.top<window.innerHeight && r.bottom>0) return;
      el.classList.add('rv'); el.setAttribute('data-d',(i%3)*90); io.observe(el);
    });
    window.addEventListener('pageshow',function(){ nodes.forEach(show); });
    setTimeout(function(){ nodes.forEach(function(el){ var r=el.getBoundingClientRect(); if(r.top<window.innerHeight) show(el); }); }, 2500);

    var co=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var el=e.target, txt=(el.textContent||'').trim(), n=parseInt(txt,10);
        if(!isNaN(n)&&String(n)===txt){
          var t0=performance.now();
          (function tick(now){
            var p=Math.min(1,(now-t0)/900);
            el.textContent=Math.round(n*(1-Math.pow(1-p,3)));
            if(p<1) requestAnimationFrame(tick);
          })(t0);
        }
        co.unobserve(el);
      });
    },{threshold:0.6});
    [].slice.call(document.querySelectorAll('.stats b')).forEach(function(el){ co.observe(el); });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
